import { connect } from 'react-redux';
import cn from 'classnames';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCatalogsKnmCanceledReasonsSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { getActCreationActDateTimeBlockId } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { IKnmCanceledReasonSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmCancelledReasonsSelectOption';
import { IKnmPmFormAct } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormAct';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

import styles from './ErknmActGeneralImpossible.module.scss';
import { ReactQuillEditorField } from '../../../../../../UIPackage/MainModule/components/ReactQuillEditorField';
import { getKnmFormRef } from '../../../../../../KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmFormRef } from '../../../../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IErknmActGeneralImpossibleProps {
  name: string;
  value: IKnmErknmFormAct | IKnmPmFormAct;
  isDisabledField: boolean;
  knmCanceledReasonsOptions: IKnmCanceledReasonSelectOption[] | undefined;
  formRef: IKnmFormRef;
  prefixId: string;
  isPm?: boolean;
  isKnm?: boolean;
}

interface IErknmActGeneralImpossibleStoreProps {
  knmCanceledReasonsOptions: IKnmCanceledReasonSelectOption[] | undefined;
  formRef: IKnmFormRef;
}

const ErknmActGeneralImpossibleWithoutStore = ({
  name,
  value,
  prefixId,
  isDisabledField,
  knmCanceledReasonsOptions,
  isPm,
  isKnm,
  formRef,
}: IErknmActGeneralImpossibleProps & IErknmActGeneralImpossibleStoreProps) => {
  const { canceledReason } = value;

  return (
    <FieldBlock label={'Основные сведения об акте'} className={styles.GroupMarginBottom}>
      <Row>
        <FieldBlock
          label={'Дата и время составления акта о невозможности проведения'}
          color="black"
          placementLabel="left"
          type="not-space"
          className={cn(styles.DateAndTimeCreation, styles.FieldBlock)}
          id={getActCreationActDateTimeBlockId(value.listId)}
        >
          <DatePickerField name={`${name}.creationActDateTime`} disabled={true} timeFormat />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'Причина невозможности проведения',
            field: `${name}.canceledReason`,
            isPm,
            isKnm,
          })}
          color="black"
          placementLabel="left"
          className={styles.FieldBlock}
          id={`${prefixId}.canceledReason`}
        >
          <SelectInputField
            name={`${name}.canceledReason`}
            options={knmCanceledReasonsOptions}
            size="medium"
            disabled={isDisabledField}
            isClearable={true}
          />
        </FieldBlock>
      </Row>
      <Row>
        {!!canceledReason && (
          <>
            <FieldBlock
              label={getTitleFieldWithRedStar({
                label: 'Описание причины невозможности проведения',
                field: `${name}.canceledReasonDescriptionReactQuillEditor`,
                isPm,
                isKnm,
              })}
              color="black"
              placementLabel="left"
              className={styles.FieldBlock}
              id={`${prefixId}.canceledReasonDescription`}
            >
              <ReactQuillEditorField
                placeholder="Введите пояснение"
                name={`${name}.canceledReasonDescriptionReactQuillEditor`}
                id={`${name}.canceledReasonDescriptionReactQuillEditor`}
                handleCustomChange={(e: string) => {
                  // @ts-ignore
                  formRef?.current?.change(`${name}.canceledReasonDescription` as never, e);
                }}
                disabled={isDisabledField}
              />
            </FieldBlock>
          </>
        )}
      </Row>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IErknmActGeneralImpossibleStoreProps => ({
  knmCanceledReasonsOptions: getCatalogsKnmCanceledReasonsSelectOptions(state),
  // @ts-ignore
  formRef: getKnmFormRef(state),
});

export const ErknmActGeneralImpossible = connect(mapStateToProps)(ErknmActGeneralImpossibleWithoutStore);
